export enum MatchOfferDeclineReason {
    DonorAge                        = 10,
    DonorAnatomy                    = 20,
    PatientAntibodies               = 30,
    EpletMismatch                   = 40,
    HlaAntigenMismatch              = 50,
    AlleleMatch                     = 60,
    DonorSize                       = 70,
    DonoreGFR                       = 80,
    DonorCC                         = 90,
    DonorIsCmvPositive              = 100,
    DonorIsEbvPositive              = 110,
    PublicHealthServicePHSIncreasedRisk = 113,
    DonorOther                      = 120,

    
    OperatingRoomNotAvailable       = 130,
    DonorSurgeonNotAvailable        = 140,
    RecipientSurgeonNotAvailable    = 150,
    PairedDonorNotAvailable         = 160,
    PatientNotAvailable             = 170,
    SurgeryDateOther                = 180,

    PatientGFRTooHigh               = 190,
    PatientInsuranceIssue           = 200,
    PatientTooSick                  = 210,
    PatientDied                     = 220,
    PatientReceivedDeceasedKidney   = 230,
    PatientTxpViaNonNkrKpd          = 240,
    PatientRecordsNeedUpdate        = 250,
    DeactivateDonorNotAvailable     = 260,
    PatientDeactivateOther          = 270
}